import { render, staticRenderFns } from "./EditTutor.vue?vue&type=template&id=75be78ea&scoped=true"
import script from "./EditTutor.vue?vue&type=script&lang=js"
export * from "./EditTutor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75be78ea",
  null
  
)

export default component.exports